import { HttpStatusCodes } from '../utils';
import {
  NewsletterSubscribeRequestDto,
  NewsletterUnsubscribeRequestDto,
} from './interfaces/newsletter-request.interface';
import { NewsletterApiResponse } from './interfaces/newsletter-subscribe-api-response.interface';

// Attention: URL to production environment
const apiURL =
  process.env.NEWSLETTER_SAP_API_AZURE_API_ENDPOINT ||
  process.env.GATSBY_NEWSLETTER_SAP_API_AZURE_API_ENDPOINT;

export const newsletterApi = async (
  payload: NewsletterSubscribeRequestDto | NewsletterUnsubscribeRequestDto,
  integrationId: string,
): Promise<NewsletterApiResponse> => {
  if (!apiURL) {
    throw new Error(
      'API endpoint not configured properly, please update environment files',
    );
  }
  const url = new URL(`${apiURL}/mpnewsletter`);

  url.searchParams.append('integrationId', integrationId);

  const options: RequestInit = {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: new Headers({
      'Content-type': 'application/json; charset=utf-8',
      'x-functions-key': `${process.env.GATSBY_NEWSLETTER_FUNCTION_KEY}`,
    }),
  };

  const response = await fetch(url, options);
  if (response.ok) {
    return await response.json();
  } else if (response.status === HttpStatusCodes.CONFLICT) {
    return await response.json();
  } else {
    throw Error(`Server error ${response.status} - ${response.statusText}`);
  }
};
